// import { createMuiTheme } from '@material-ui/core/styles';

export const theme = {
  palette: {
    mode: 'light',
    grey: {
      50: '#fff',
      100: '#fff',
      200: '#323232',
      300: '#FFFBEFE6',
      400: '#E0E0E0',
      500: '#EEEEEE',
      600: '#F9F9F9',
      700: '#E0E0E0',
      800: '#FBFBFD',
    },
    secondary: {
      main: '#DC9E00',
      dark: '#DC9e00CC',
      darker: '#916A05',
      lighter: '#FFF2CF',
      contrastText: '#FFF',
    },
    primary: {
      main: '#499557',
      dark: '#308140',
      contrastText: '#fff',
    },
    error: {
      main: '#FB3F4B',
      dark: '#FFEFEF',
      contrastText: '#FF0000',
    },
    background: {
      default: '#f1f1f1',
      paper: '#fff',
    },
    neutral: {
      100: '#F7F7F7',
    },
    text: {
      primary: '#252525',
      secondary: '#505050',
      disabled: '#A0A0A0',
      tooltip: '#DCDCDC',
    },
    divider: '#DEE1E3',
  },
  typography: {
    fontFamily: "'Open Sans', sans-serif",
    allVariants: {
      color: '#252525',
    },
  },
  specialColors: {
    WORD_DIFF_COLOR: '#E36B00',
    STRUCT_DIFF_COLOR: '#FFDD2E',
    LCS_COLOR: '#006ACC',
    BLUE_HIGHLIGHT: '#EDFAFF',
    YELLOW_HIGHLIGHT: '#FEFFD8',
    FREEZE_WORD_COLOR: '#00747B',
    FREEZE_WORD_ARROW: '#00747B',
    SKELETON: '#EEEEEE',
    THESAURUS: '#5000B9',
    AFFILIATE_TABLE: '#D6F4DD54',
    CIRCULAR_PROGRESS: '#DCDCDC',
    GRAMMAR_CHECKER_TABLE_TOPIC: '#EDFAFF',
    GRAMMAR_CHECKER_TABLE_RIGHT: '#D6F4DD',
    GRAMMAR_CHECKER_FONT_BLUE: '#1E6592',
    GRAMMAR_CHECKER_FONT_GREEN: '#499557',
    TEXT_SELECTION: '#B9E7F9',
    REPORT_HOVER_COLOR: '#E13636',
    CHECKBOX_DEFAULT: '#5F6368',
    BLUE_COLOR: '#2971FE',
    THESAURUS_ORIGINAL_WORD_BG: '#EBDCFF',
    MAIN_MENU_BG: '#202020',
    MAIN_MENU_TEXT: '#DCDCDC',
    SWITCH_THEME_BG: '#121212',
    MAIN_MENU_DIVIDER: '#3C3E3E',
    HIGHLIGHTED_TEXT: '#000000',
    ICON_DEFAULT_COLOR: '#5F6368',
    CHECKOUT_PAGE_BG: '#F7F9FB',
    TOAST_COLOR: '#2389F8',
    LOADING_BAR: '#FFFFFF',
    SMZR_KEYWORD: '#BD5800',
    THREE_BEAM: '#FFFFFF',
    SWITCH_THEME_ICON: '#575757',
    ONBOARDING_0: '#499557',
    ONBOARDING_1: '#319DFF',
    ONBOARDING_2: '#8F66FF',
    ONBOARDING_3: '#F2B518',
    ONBOARDING_4: '#FF616B',
    WHITE_TEXT: '#FFFFFF',
    STEPPER_DOTS: '#00000042',
    WARNING_BAR: '#F2B518',
    TINYMCE_LOGO_COLOR: '#5F6368',
    GRAY_TEXT_COLOR: '#818181',
    CO_WRITER_BLACK: '#2d2d2d',
    GRAY_BORDER_COLOR: '#C2C2C2',
    CG_INFO_BG: '#F7F9FB',
  },
  shadows: [
    'none',
    '0px 4px 22px 0px #0000000A',
    '0px 4px 15px 0px #73737326',
    '0px 4px 22px 0px #00000033',
    '0px 1px 6px 0px #00000040',
    '0px 2px 3px 0px #00000026',
    '0px 3px 10px 0px #00000040',
  ],
  spacing: 2,

  components: {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '*::-webkit-scrollbar': {
          width: '5px',
          cursor: 'default',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: '#C2C2C2',
          borderColor: '#C2C2C2',
        },
        '*::-webkit-scrollbar-track': {
          borderRadius: '10px',
        },
        '*::-webkit-scrollbar-track-piece': {
          backgroundColor: '#F1F1F1',
        },
        'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, textarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus, select:-webkit-autofill, select:-webkit-autofill:hover, select:-webkit-autofill:focus':
          {
            '-webkit-box-shadow': '0 0 0px 1000px #FFFFFF inset !important',
          },
        a: {
          color: '#2971FE',
        },
        body: {
          fontSize: '0.875rem',
          lineHeight: 1.43,
          // letterSpacing: '0.01071em',
        },
      },
    },
    typography: {
      styleOverrides: {
        fontFamily: "'Open Sans', sans-serif",
        button: {
          textTransform: undefined,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#323232',
          boxShadow: '0px 4px 5px #00000021',
          color: '#DCDCDC',
          fontSize: '0.625rem',
          margin: 0,
        },
        arrow: {
          color: '#323232',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Open Sans', sans-serif",
          boxShadow: 'none !important',
          textTransform: 'none',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#5F6368',
          '&:hover': {
            color: '#308140',
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          // color: '#5F6368',
          // '&:hover': {
          //   color: '#499557',
          // },
        },
        colorDisabled: {
          color: '#A0A0A0',
          '&:hover': {
            color: '#A0A0A0',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          fontFamily: "'Open Sans', sans-serif",
          backgroundImage: 'unset',
          // color: '#252525',
          // '& p': {
          //   color: '#252525',
          // },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#f1f1f1',
          },
          '&$selected': {
            '&:hover': {
              backgroundColor: '#F1E6FF',
            },
            backgroundColor: '#F1E6FF',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: '#252525',
        },
      },
    },
    MuiTouchRipple: {
      styleOverrides: {
        root: {
          opacity: '40%',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
          '&:hover': {
            backgroundColor: '#fff',
          },
          '&$focused': {
            backgroundColor: '#fff',
          },
        },
      },
    },
  },
};

export const darkMode = {
  palette: {
    mode: 'dark',
    grey: {
      50: '#202020',
      100: '#191A1C',
      200: '#EEEEEE',
      300: '#211C10E6',
      400: '#323232',
      500: '#323232',
      600: '#1A1A1A',
      700: '#3F3F3F',
      800: '#191A1C',
    },
    secondary: {
      main: '#DC9E00',
      dark: '#DC9e00CC',
      darker: '#FFE193',
      lighter: '#383222',
      contrastText: '#FFF',
    },
    primary: {
      main: '#499557',
      dark: '#308140',
      contrastText: '#fff',
    },
    error: {
      main: '#FB3F4B',
      dark: '#3F1616',
      contrastText: '#FF0000',
    },
    background: {
      default: '#121212',
      paper: '#202020',
    },
    text: {
      primary: '#DCDCDC',
      secondary: '#AAAAAA',
      disabled: '#575757',
      tooltip: '#252525',
    },
    divider: '#3C3E3E',
  },
  typography: {
    fontFamily: "'Open Sans', sans-serif",
    allVariants: {
      color: '#DCDCDC',
    },
  },
  specialColors: {
    WORD_DIFF_COLOR: '#FF9330',
    STRUCT_DIFF_COLOR: '#FBE361',
    LCS_COLOR: '#72BBFF',
    BLUE_HIGHLIGHT: '#172B3D',
    YELLOW_HIGHLIGHT: '#413716',
    FREEZE_WORD_COLOR: '#81F5FC',
    FREEZE_WORD_ARROW: '#00747B',
    SKELETON: '#323232',
    THESAURUS: '#D299FF',
    AFFILIATE_TABLE: '#294A2F54',
    CIRCULAR_PROGRESS: '#2F2F2F',
    GRAMMAR_CHECKER_TABLE_TOPIC: '#0F3960',
    GRAMMAR_CHECKER_TABLE_RIGHT: '#1D3C22',
    GRAMMAR_CHECKER_FONT_BLUE: '#5CA0CA',
    GRAMMAR_CHECKER_FONT_GREEN: '#499557',
    TEXT_SELECTION: '#0F3960',
    BLUE_COLOR: '#2389F8',
    THESAURUS_ORIGINAL_WORD_BG: '#311A42',
    CHECKBOX_DEFAULT: '#B3B5B7',
    REPORT_HOVER_COLOR: '#E13636',
    MAIN_MENU_BG: '#202020',
    MAIN_MENU_TEXT: '#DCDCDC',
    SWITCH_THEME_BG: '#121212',
    MAIN_MENU_DIVIDER: '#3C3E3E',
    HIGHLIGHTED_TEXT: '#ffffff',
    ICON_DEFAULT_COLOR: '#B3B5B7',
    CHECKOUT_PAGE_BG: '#1B1B1B',
    TOAST_COLOR: '#2971FE',
    LOADING_BAR: '#DCDCDC',
    SMZR_KEYWORD: '#BD5800',
    THREE_BEAM: '#323232',
    WHITE_TEXT: '#FFFFFF',
    SWITCH_THEME_ICON: '#575757',
    WARNING_BAR: '#D9932A',
    TINYMCE_LOGO_COLOR: '#B3B5B7',
    GRAY_TEXT_COLOR: '#818181',
    CO_WRITER_BLACK: '#2d2d2d',
    GRAY_BORDER_COLOR: '#C2C2C2',
    CG_INFO_BG: '#F7F9FB',
  },
  shadows: [
    'none',
    '0px 6px 25px 0px #0000004D',
    '0px 3px 15px 0px #00000073',
    '0px 4px 22px 0px #00000073',
    '0px 4px 22px 0px #00000073',
    '0px 2px 3px 0px #00000026',
    '0px 3px 10px 0px #0000008C',
  ],
  components: {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: '#5F5F60',
          borderColor: '#5F5F60',
        },
        '*::-webkit-scrollbar': {
          width: '5px',
          cursor: 'default',
        },
        '*::-webkit-scrollbar-track': {
          borderRadius: '10px',
        },
        '*::-webkit-scrollbar-track-piece': {
          backgroundColor: '#121212',
        },
        'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, textarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus, select:-webkit-autofill, select:-webkit-autofill:hover, select:-webkit-autofill:focus':
          {
            '-webkit-box-shadow': '0 0 0px 1000px #202020 inset !important',
          },
        a: {
          color: '#2389F8',
        },
        body: {
          fontSize: '0.875rem',
          lineHeight: 1.43,
          // letterSpacing: '0.01071em',
        },
      },
    },
    typography: {
      styleOverrides: {
        fontFamily: "'Open Sans', sans-serif",
        button: {
          textTransform: undefined,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#eee',
          boxShadow: '0px 4px 22px 0px #00000026',
          color: '#252525',
        },
        arrow: {
          color: '#eee',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Open Sans', sans-serif",
          boxShadow: 'none !important',
          textTransform: 'none',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#B3B5B7',
          '&:hover': {
            color: '#308140',
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          // color: '#B3B5B7',
          // '&:hover': {
          //   color: '#499557',
          // },
        },
        colorDisabled: {
          color: '#575757',
          '&:hover': {
            color: '#575757',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          fontFamily: "'Open Sans', sans-serif",
          backgroundImage: 'unset',
          // color: '#A2A6A8',
          // '& p': {
          //   // color: '#A2A6A8',
          // },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#121212',
          },
          '&$selected': {
            '&:hover': {
              backgroundColor: '#3F2D4D',
            },
            backgroundColor: '#3F2D4D',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: '#A2A6A8',
        },
      },
    },
    MuiTouchRipple: {
      styleOverrides: {
        root: {
          opacity: '40%',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#202020',
          '&:hover': {
            backgroundColor: '#202020',
          },
          '&$focused': {
            backgroundColor: '#202020',
          },
        },
      },
    },
  },
};

export const litcharts = {
  palette: {
    mode: 'light',
    grey: {
      50: '#fff',
      100: '#fff',
      200: '#323232',
      300: '#FFFBEFE6',
      400: '#E0E0E0',
      500: '#EEEEEE',
      600: '#F9F9F9',
      700: '#E0E0E0',
      800: '#FBFBFD',
    },
    secondary: {
      main: '#DC5F5F',
      dark: '#DC5F5FCC',
      contrastText: '#FFF',
    },
    primary: {
      main: '#1A61ED',
      dark: '#3171EF',
      contrastText: '#fff',
    },
    error: {
      main: '#FB3F4B',
      dark: '#FFEFEF',
      contrastText: '#FF0000',
    },
    background: {
      default: '#f1f1f1',
      paper: '#fff',
    },
    neutral: {
      100: '#191919',
    },
    text: {
      primary: '#252525',
      secondary: '#505050',
      disabled: '#A0A0A0',
      tooltip: '#DCDCDC',
    },
    divider: '#DEE1E3',
  },
  typography: {
    fontFamily: "'Nunito Sans', sans-serif",
    allVariants: {
      color: '#252525',
    },
  },
  specialColors: {
    WORD_DIFF_COLOR: '#E36B00',
    STRUCT_DIFF_COLOR: '#FFDD2E',
    LCS_COLOR: '#006ACC',
    BLUE_HIGHLIGHT: '#EDFAFF',
    YELLOW_HIGHLIGHT: '#FEFFD8',
    FREEZE_WORD_COLOR: '#00747B',
    FREEZE_WORD_ARROW: '#00747B',
    SKELETON: '#EEEEEE',
    THESAURUS: '#5000B9',
    AFFILIATE_TABLE: '#D6F4DD54',
    CIRCULAR_PROGRESS: '#DCDCDC',
    GRAMMAR_CHECKER_TABLE_TOPIC: '#EDFAFF',
    GRAMMAR_CHECKER_TABLE_RIGHT: '#D6F4DD',
    GRAMMAR_CHECKER_FONT_BLUE: '#1E6592',
    GRAMMAR_CHECKER_FONT_GREEN: '#499557',
    TEXT_SELECTION: '#B9E7F9',
    REPORT_HOVER_COLOR: '#E13636',
    CHECKBOX_DEFAULT: '#5F6368',
    BLUE_COLOR: '#2971FE',
    THESAURUS_ORIGINAL_WORD_BG: '#EBDCFF',
    MAIN_MENU_BG: '#202020',
    MAIN_MENU_TEXT: '#DCDCDC',
    SWITCH_THEME_BG: '#121212',
    MAIN_MENU_DIVIDER: '#3C3E3E',
    HIGHLIGHTED_TEXT: '#000000',
    ICON_DEFAULT_COLOR: '#5F6368',
    CHECKOUT_PAGE_BG: '#F7F9FB',
    TOAST_COLOR: '#2389F8',
    LOADING_BAR: '#FFFFFF',
    SMZR_KEYWORD: '#BD5800',
    THREE_BEAM: '#FFFFFF',
    SWITCH_THEME_ICON: '#575757',
    ONBOARDING_0: '#499557',
    ONBOARDING_1: '#319DFF',
    ONBOARDING_2: '#8F66FF',
    ONBOARDING_3: '#F2B518',
    ONBOARDING_4: '#FF616B',
    ONBOARDING_ACCORDIAN: '#686868',
    WHITE_TEXT: '#FFFFFF',
    STEPPER_DOTS: '#00000042',
    WARNING_BAR: '#F2B518',
    TINYMCE_LOGO_COLOR: '#5F6368',
    GRAY_TEXT_COLOR: '#818181',
    CO_WRITER_BLACK: '#2d2d2d',
    GRAY_BORDER_COLOR: '#C2C2C2',
    CG_INFO_BG: '#F7F9FB',
  },
  shadows: [
    'none',
    '0px 4px 22px 0px #0000000A',
    '0px 4px 15px 0px #73737326',
    '0px 4px 22px 0px #00000033',
    '0px 1px 6px 0px #00000040',
    '0px 2px 3px 0px #00000026',
    '0px 3px 10px 0px #00000040',
  ],

  components: {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '*::-webkit-scrollbar': {
          width: '5px',
          cursor: 'default',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: '#C2C2C2',
          borderColor: '#C2C2C2',
        },
        '*::-webkit-scrollbar-track': {
          borderRadius: '10px',
        },
        '*::-webkit-scrollbar-track-piece': {
          backgroundColor: '#F1F1F1',
        },
        'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, textarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus, select:-webkit-autofill, select:-webkit-autofill:hover, select:-webkit-autofill:focus':
          {
            '-webkit-box-shadow': '0 0 0px 1000px #FFFFFF inset !important',
          },
        a: {
          color: '#2971FE',
        },
        body: {
          fontSize: '0.875rem',
          lineHeight: 1.43,
          // letterSpacing: '0.01071em',
        },
      },
    },
    typography: {
      styleOverrides: {
        fontFamily: "'Open Sans', sans-serif",
        button: {
          textTransform: undefined,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#323232',
          boxShadow: '0px 4px 5px #00000021',
          color: '#DCDCDC',
          fontSize: '0.625rem',
          margin: 0,
        },
        arrow: {
          color: '#323232',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Open Sans', sans-serif",
          boxShadow: 'none !important',
          textTransform: 'none',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#5F6368',
          '&:hover': {
            color: '#308140',
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          // color: '#5F6368',
          // '&:hover': {
          //   color: '#499557',
          // },
        },
        colorDisabled: {
          color: '#A0A0A0',
          '&:hover': {
            color: '#A0A0A0',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          fontFamily: "'Open Sans', sans-serif",
          backgroundImage: 'unset',
          // color: '#252525',
          // '& p': {
          //   color: '#252525',
          // },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#f1f1f1',
          },
          '&$selected': {
            '&:hover': {
              backgroundColor: '#F1E6FF',
            },
            backgroundColor: '#F1E6FF',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: '#252525',
        },
      },
    },
    MuiTouchRipple: {
      styleOverrides: {
        root: {
          opacity: '40%',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
          '&:hover': {
            backgroundColor: '#fff',
          },
          '&$focused': {
            backgroundColor: '#fff',
          },
        },
      },
    },
  },
};

export const herokuapp = {
  palette: {
    mode: 'light',
    grey: {
      50: '#fff',
      100: '#fff',
      200: '#323232',
      300: '#FFFBEFE6',
      400: '#E0E0E0',
      500: '#EEEEEE',
      600: '#F9F9F9',
      700: '#E0E0E0',
      800: '#FBFBFD',
    },
    secondary: {
      main: '#DC5F5F',
      dark: '#DC5F5FCC',
      contrastText: '#FFF',
    },
    primary: {
      main: '#1A61ED',
      dark: '#3171EF',
      contrastText: '#fff',
    },
    error: {
      main: '#FB3F4B',
      dark: '#FFEFEF',
      contrastText: '#FF0000',
    },
    background: {
      default: '#f1f1f1',
      paper: '#fff',
    },
    text: {
      primary: '#252525',
      secondary: '#505050',
      disabled: '#A0A0A0',
      tooltip: '#DCDCDC',
    },
    divider: '#DEE1E3',
  },
  typography: {
    fontFamily: "'Nunito Sans', sans-serif",
    allVariants: {
      color: '#252525',
    },
  },
  specialColors: {
    WORD_DIFF_COLOR: '#E36B00',
    STRUCT_DIFF_COLOR: '#FFDD2E',
    LCS_COLOR: '#006ACC',
    BLUE_HIGHLIGHT: '#EDFAFF',
    YELLOW_HIGHLIGHT: '#FEFFD8',
    FREEZE_WORD_COLOR: '#00747B',
    FREEZE_WORD_ARROW: '#00747B',
    SKELETON: '#EEEEEE',
    THESAURUS: '#5000B9',
    AFFILIATE_TABLE: '#D6F4DD54',
    CIRCULAR_PROGRESS: '#DCDCDC',
    GRAMMAR_CHECKER_TABLE_TOPIC: '#EDFAFF',
    GRAMMAR_CHECKER_TABLE_RIGHT: '#D6F4DD',
    GRAMMAR_CHECKER_FONT_BLUE: '#1E6592',
    GRAMMAR_CHECKER_FONT_GREEN: '#499557',
    TEXT_SELECTION: '#B9E7F9',
    REPORT_HOVER_COLOR: '#E13636',
    CHECKBOX_DEFAULT: '#5F6368',
    BLUE_COLOR: '#2971FE',
    THESAURUS_ORIGINAL_WORD_BG: '#EBDCFF',
    MAIN_MENU_BG: '#202020',
    MAIN_MENU_TEXT: '#DCDCDC',
    SWITCH_THEME_BG: '#121212',
    MAIN_MENU_DIVIDER: '#3C3E3E',
    HIGHLIGHTED_TEXT: '#000000',
    ICON_DEFAULT_COLOR: '#5F6368',
    CHECKOUT_PAGE_BG: '#F7F9FB',
    TOAST_COLOR: '#2389F8',
    LOADING_BAR: '#FFFFFF',
    SMZR_KEYWORD: '#BD5800',
    THREE_BEAM: '#FFFFFF',
    SWITCH_THEME_ICON: '#575757',
    ONBOARDING_0: '#499557',
    ONBOARDING_1: '#319DFF',
    ONBOARDING_2: '#8F66FF',
    ONBOARDING_3: '#F2B518',
    ONBOARDING_4: '#FF616B',
    WHITE_TEXT: '#FFFFFF',
    STEPPER_DOTS: '#00000042',
    WARNING_BAR: '#F2B518',
    TINYMCE_LOGO_COLOR: '#5F6368',
    GRAY_TEXT_COLOR: '#818181',
    CO_WRITER_BLACK: '#2d2d2d',
    GRAY_BORDER_COLOR: '#C2C2C2',
    CG_INFO_BG: '#F7F9FB',
  },
  shadows: [
    'none',
    '0px 4px 22px 0px #0000000A',
    '0px 4px 15px 0px #73737326',
    '0px 4px 22px 0px #00000033',
    '0px 1px 6px 0px #00000040',
    '0px 2px 3px 0px #00000026',
    '0px 3px 10px 0px #00000040',
  ],

  components: {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '*::-webkit-scrollbar': {
          width: '5px',
          cursor: 'default',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: '#C2C2C2',
          borderColor: '#C2C2C2',
        },
        '*::-webkit-scrollbar-track': {
          borderRadius: '10px',
        },
        '*::-webkit-scrollbar-track-piece': {
          backgroundColor: '#F1F1F1',
        },
        'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, textarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus, select:-webkit-autofill, select:-webkit-autofill:hover, select:-webkit-autofill:focus':
          {
            '-webkit-box-shadow': '0 0 0px 1000px #FFFFFF inset !important',
          },
        a: {
          color: '#2971FE',
        },
        body: {
          fontSize: '0.875rem',
          lineHeight: 1.43,
          // letterSpacing: '0.01071em',
        },
      },
    },
    typography: {
      styleOverrides: {
        fontFamily: "'Open Sans', sans-serif",
        button: {
          textTransform: undefined,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#323232',
          boxShadow: '0px 4px 5px #00000021',
          color: '#DCDCDC',
          fontSize: '0.625rem',
          margin: 0,
        },
        arrow: {
          color: '#323232',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Open Sans', sans-serif",
          boxShadow: 'none !important',
          textTransform: 'none',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#5F6368',
          '&:hover': {
            color: '#308140',
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          // color: '#5F6368',
          // '&:hover': {
          //   color: '#499557',
          // },
        },
        colorDisabled: {
          color: '#A0A0A0',
          '&:hover': {
            color: '#A0A0A0',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          fontFamily: "'Open Sans', sans-serif",
          backgroundImage: 'unset',
          // color: '#252525',
          // '& p': {
          //   color: '#252525',
          // },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#f1f1f1',
          },
          '&$selected': {
            '&:hover': {
              backgroundColor: '#F1E6FF',
            },
            backgroundColor: '#F1E6FF',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: '#252525',
        },
      },
    },
    MuiTouchRipple: {
      styleOverrides: {
        root: {
          opacity: '40%',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
          '&:hover': {
            backgroundColor: '#fff',
          },
          '&$focused': {
            backgroundColor: '#fff',
          },
        },
      },
    },
  },
};

// export default createMuiTheme(theme);
export type Themetype = typeof theme;
